class SliderComponent extends HTMLElement {
  constructor() {
    super();
    
    this.slider = this.querySelector('[id^="Slider-"]');
    if (!this.slider) return;
    
    this.slideItems = Array.from(this.querySelectorAll('[id^="Slide-"]'));
    this.currentPage = 1;
    this.totalPage = this.slideItems.length;
    this.enableSliderLooping = this.hasAttribute('loop');
    
    this.init();
  }
  
  init() {
    this.totalPage = this.getTotalPage();
    
    this.slider.addEventListener('scroll', this.throttle(this.slideUpdate.bind(this), 100));
    
    const resizeObserver = new ResizeObserver(this.throttle(this.initSlides.bind(this), 100));
    resizeObserver.observe(this.slider);
    
    this.updateView();
  }
  
  initSlides() {
    this.totalPage = this.getTotalPage();
    this.updateView();
  }
  
  get direction() {
    return this.getAttribute('direction') === 'vertical' ? 'vertical' : 'horizontal';
  }
  
  throttle(func, limit) {
    let inThrottle;
    return function() {
      const args = arguments;
      const context = this;
      if (!inThrottle) {
        func.apply(context, args);
        inThrottle = true;
        setTimeout(() => inThrottle = false, limit);
      }
    };
  }
  
  getTotalPage() {
    if (this.slideItems.length === 1) return 1;
    
    const sliderWidth = this.slider.clientWidth;
    const sliderHeight = this.slider.clientHeight;
    const sliderScrollWidth = this.slider.scrollWidth;
    const sliderScrollHeight = this.slider.scrollHeight;
    let slideWithInScreenNum = 1;
    
    for (let i = this.slideItems.length - 2; i >= 0; i--) {
      const slide = this.slideItems[i];
      
      if (this.direction === 'horizontal') {
        if (sliderScrollWidth - slide.offsetLeft - sliderWidth > -1) {
          return this.slideItems.length - slideWithInScreenNum + 1;
        }
      }
      
      if (this.direction === 'vertical') {
        if (sliderScrollHeight - slide.offsetTop - sliderHeight > -1) {
          return this.slideItems.length - slideWithInScreenNum + 1;
        }
      }
      
      slideWithInScreenNum++;
    }
    
    return 1;
  }
  
  slideUpdate() {
    const idx = this.slideItems.findIndex((slide) => this.isSlideVisible(slide));
    
    if (idx < 0 || idx >= this.totalPage) return;
    
    const previousPage = this.currentPage;
    this.currentPage = idx + 1;
    
    if (previousPage !== this.currentPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', {
        detail: {
          currentPage: this.currentPage,
          currentElement: this.slideItems[idx]
        }
      }));
      
      this.updateView();
    }
  }
  
  isSlideVisible(element) {
    if (this.direction === 'vertical') {
      return (
        element.offsetTop - this.slider.scrollTop > -1 &&
        this.slider.clientHeight + this.slider.scrollTop - (element.offsetTop + element.clientHeight) > -1
      );
    }
    return (
      element.offsetLeft - this.slider.scrollLeft > -1 &&
      this.slider.clientWidth + this.slider.scrollLeft - (element.offsetLeft + element.clientWidth) > -1
    );
  }
  
  updateView() {
    this.slideItems.forEach((slide, idx) => {
      if (idx === this.currentPage - 1) {
        slide.classList.add('is-active');
      } else {
        slide.classList.remove('is-active');
      }
    });
  }
  
  slideTo(idx) {
    if (idx === this.currentPage) return;
    
    const targetSlide = this.slideItems[idx - 1];
    if (targetSlide) {
      if (this.direction === 'vertical') {
        this.slider.scrollTo({ top: targetSlide.offsetTop });
      } else {
        this.slider.scrollTo({ left: targetSlide.offsetLeft });
      }
    }
  }
}

customElements.define('slider-component', SliderComponent);